import { REF_PARAM } from "@/lib/services/utm"

const DESTINATION_PARAM = "to"

const UTM_PREFIX = "utm_"

export const whatsappShareUrl = (message: string): string => `https://wa.me/?text=${encodeURIComponent(message)}`

export const facebookShareUrl = (link: string): string => `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(link)}`

export const productShareLink = (shareUrl: string, productPath: string, search = ""): string => {
  const params = new URLSearchParams(search)
  for (const key of [...params.keys()]) {
    if (key === REF_PARAM || key === DESTINATION_PARAM || key.startsWith(UTM_PREFIX)) params.delete(key)
  }
  const query = params.toString()
  return `${shareUrl}?${DESTINATION_PARAM}=${encodeURIComponent(query ? `${productPath}?${query}` : productPath)}`
}
